import { useEffect } from "react";
import {
  usePrismicDocumentsByType,
  useSinglePrismicDocument,
} from "@prismicio/react";
import * as prismicH from "@prismicio/helpers";

import { Layout } from "../components/Layout";
import { Header } from "../components/Header";
import { PostList } from "../components/PostList";
import { NotFound } from "./NotFound";
import { getCurrentLocale } from "../locale";

/**
 * Blog homepage component
 */
export const Home = () => {


  const [homeDoc, homeDocState] = useSinglePrismicDocument("blog_home", {lang: getCurrentLocale()});
  const [blogPosts, blogPostsState] = usePrismicDocumentsByType("post", {lang: getCurrentLocale()},  {
    orderings: [{ field: "my.post.date", direction: "desc" }],
  });

  const notFound =
    homeDocState.state === "failed" || blogPostsState.state === "failed";

  useEffect(() => {
    if (!homeDocState.state === "failed") {
     
    }
  }, [homeDocState.state]);

  // Return the page if a document was retrieved from Prismic
  if (homeDoc && blogPosts?.results) {
    const title = prismicH.asText(homeDoc.data.headline);

    return (
      <Layout seoTitle={title}>
        <div
        onClick={() => window.location.href='https://taskycal.com'}
        style={{textAlign:'center',   margin:'0 auto', alignItems:'center',
        textDecorationLine:'underline',cursor:'pointer', 
        justifyContent:'center'}}>
        <img src={'https://taskycal.com/assets/images/favicon.png'}
        style={{height: 40, width: 40,}}/>
       <div style={{fontWeight:'bold', fontFamily:'Poppins', color:'#8C0F9',}}> TaskyCal</div>
        </div>
        <Header
          image={homeDoc.data.image}
         
          description={homeDoc.data.description}
        />
        <PostList posts={blogPosts?.results} />
      </Layout>
    );
  } else if (notFound) {
    return <NotFound />;
  }

  return null;
};
